var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { computeAccessibleName, getRole } from 'dom-accessibility-api';
import { fetchInterceptors, networkStatus, pageVisibilityChangeListener } from './';
import { dtRum } from './dtRum';
var defaultOptions = {
    rootElement: document.body,
    enableFetchInterceptors: true,
    defaultQuerySelectors: 'a, [role="link"], button, [role="button"]',
    enableAutomaticActionDetection: true,
    enableNetworkStatusCheck: true,
    enablePageVisibilityChangeListener: true,
};
/**
 * Função responsável por capturar os eventos de click da página.
 * Deve ser implementado o ariaLabel para a captura do evento.
 * Caso não queira capturar alguma evento deve ser adicionado um atributo no-automatic-track="true".
 *
 * @returns object contém uma função dynatraceRemoveAutoListeners
 */
export var dynatraceInit = function (options) {
    var _a = __assign(__assign({}, defaultOptions), options), rootElement = _a.rootElement, defaultQuerySelectors = _a.defaultQuerySelectors, enableFetchInterceptors = _a.enableFetchInterceptors, enableAutomaticActionDetection = _a.enableAutomaticActionDetection, enableNetworkStatusCheck = _a.enableNetworkStatusCheck, enablePageVisibilityChangeListener = _a.enablePageVisibilityChangeListener;
    var getDefaultSelectors = function (rootElement) { return rootElement.querySelectorAll(defaultQuerySelectors); };
    var eventListener = function (event) {
        if (!dtRum)
            return;
        var paths = event.composedPath();
        var foundElement = paths.find(function (eventPath) {
            var _a;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var hasListener = !!((_a = eventPath === null || eventPath === void 0 ? void 0 : eventPath.attributes) === null || _a === void 0 ? void 0 : _a.listener);
            return hasListener;
        });
        var e = foundElement;
        var accessibleName = computeAccessibleName(e) || 'no accessible text';
        var role = getRole(e) || 'generic';
        var actionNameDescription = "click on ".concat(role, ": \"").concat(accessibleName, "\"");
        var action = dtRum.enterAction(actionNameDescription);
        dtRum.leaveAction(action);
        enableAutomaticActionDetection === false && dtRum.setAutomaticActionDetection(false);
    };
    var addEventListenerByRootElement = function (rootElement) {
        var clickableElements = getDefaultSelectors(rootElement);
        clickableElements.forEach(function (element) {
            if (element.getAttribute('listener') !== 'true' && !element.hasAttribute('no-automatic-track')) {
                element.setAttribute('listener', 'true');
                element.addEventListener('click', eventListener, false);
            }
        });
    };
    var removeEventListenerByRootElement = function (rootElement) {
        var clickableElements = rootElement.querySelectorAll('[listener]');
        clickableElements.forEach(function (element) {
            element.removeEventListener('click', eventListener, false);
            element.removeAttribute('listener');
        });
    };
    addEventListenerByRootElement(rootElement);
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
            if (mutationRecord.target.nodeName !== 'BODY') {
                var mutationRecordElement = mutationRecord.target;
                addEventListenerByRootElement(mutationRecordElement);
            }
        });
    });
    observer.observe(rootElement, {
        subtree: true,
        childList: true,
    });
    var unsubFetchInterceptors = enableFetchInterceptors ? fetchInterceptors() : undefined;
    var unsubDynatraceNetworkStatus = enableNetworkStatusCheck ? networkStatus() : undefined;
    var unsubPageVisiblityChangeListener = enablePageVisibilityChangeListener ? pageVisibilityChangeListener() : undefined;
    return function () {
        observer.disconnect();
        enableAutomaticActionDetection === false && (dtRum === null || dtRum === void 0 ? void 0 : dtRum.setAutomaticActionDetection(true));
        removeEventListenerByRootElement(rootElement);
        unsubFetchInterceptors && unsubFetchInterceptors();
        unsubDynatraceNetworkStatus && unsubDynatraceNetworkStatus();
        unsubPageVisiblityChangeListener && unsubPageVisiblityChangeListener();
    };
};
export default dynatraceInit;
//# sourceMappingURL=dynatraceInit.js.map